import React, { useState } from "react";
import { Cog } from 'lucide-react';
import { NavItem } from "../NavItem";

export function SettingsLink({ isCollapsed, currentPath }) {
    // 1. Define the data structure for sub-items
    const settingsSubItems = [
        { id: 'sys-set', label: 'System Settings', url: '/system-settings' },
        { id: 'auth', label: 'Authentication', url: '/auth' },
        { id: 'alerts', label: 'Alert Notifications', url: '/alert-notifications' },
        { id: 'license', label: 'License', url: '/license' },
        { id: 'logs', label: 'Logs', url: '/logs' },
        { id: 'upgrade', label: 'Upgrade', url: '/upgrade' },
        { id: 'backup', label: 'Backups', url: '/backup' },
        { id: 'status', label: 'System Status', url: '/system' },
    ];

    const subRoutes = settingsSubItems.map(item => item.url);
    const isChildActive = subRoutes.includes(currentPath);
    const [isExpanded, setIsExpanded] = useState(isChildActive);

    React.useEffect(() => {
        if (isChildActive) setIsExpanded(true);
    }, [isChildActive]);

    return (
        <NavItem
            Icon={Cog}
            label="Settings"
            isCollapsed={isCollapsed}
            hasSubItems={true}
            isExpanded={isExpanded}
            onToggle={() => setIsExpanded(!isExpanded)}
            isActive={isChildActive}
            // 2. Pass the array here
            subItems={settingsSubItems} 
        >
            {/* Standard Sidebar Submenu (Visible when expanded & NOT collapsed) */}
            {isExpanded && !isCollapsed && (
                <ul className="submenu-list">
                    {settingsSubItems.map(item => (
                        <NavItem
                            key={item.id}
                            redirectUrl={item.url}
                            label={item.label}
                            isActive={currentPath === item.url}
                        />
                    ))}
                </ul>
            )}
        </NavItem>
    );
}